export * from './capitalize.pipe'
export * from './plural.pipe'
export * from './round.pipe'
export * from './timing.pipe'
export * from './number-with-commas.pipe'
export * from './default-lang.pipe'
export * from './extend-date-pipe'
export * from './truncate.pipe'
export * from './default-lang.pipe'
export * from './trim.pipe'
